import { render } from "./AssetReports.vue?vue&type=template&id=6cef01b2"
import script from "./AssetReports.vue?vue&type=script&lang=js"
export * from "./AssetReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__